import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

import * as ui from "../../../models/ui"
import * as model from "../../../models"
import { ShoppingCartTicketGroupDTO } from "../../../services/webservice"
import { TicketCreationDTO } from "../../../services/webservice"
import { NumberField } from '../../../ui-helper';

@Component({
	selector: 'ticket-categories',
	templateUrl: "./ticket-categories.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./ticket-categories.scss")]
})
export class TicketCategories {

	@Output() ticketCreationDTOsCreated: EventEmitter<TicketCreationDTO[]> = new EventEmitter<TicketCreationDTO[]>();

	private _displayCategories: DisplayCategoryWithControls[] = []
	private _ticketQuota: model.TicketQuota
	private availability: { [key: string]: number; };

	@Input() set ticketQuota(ticketQuota: model.TicketQuota) {
		this._ticketQuota = ticketQuota
		this.availability = {}
		ticketQuota.ticketQuotaStatus.forEach(ticketQuotaStatus => {
			this.availability[ticketQuotaStatus.category.uuid] = ticketQuotaStatus.availableTickets
		});
		this.resetForm();
	}

	@Input() set displayCategories(displayCategories: ui.DisplayCategory[]) {
		this._displayCategories = []
		displayCategories.forEach(displayCategory => {
			let displayCategoryWithControls: DisplayCategoryWithControls = displayCategory
			displayCategoryWithControls.standardPriceLevelControl = new FormControl("")
			displayCategoryWithControls.reducedPriceLevelsWithControl = []
			if (displayCategory.combinedPriceLevel) {
				displayCategory.combinedPriceLevel.reduced.forEach(reducedPriceLevel => {
					let reducedPriceLevelWithControl: PriceLevelWithControl = reducedPriceLevel
					reducedPriceLevelWithControl.control = new FormControl("")
					displayCategoryWithControls.reducedPriceLevelsWithControl.push(reducedPriceLevelWithControl)
				});
			}
			this._displayCategories.push(displayCategoryWithControls)
		});
	}

	submitForm() {
		let ticketCreationDTOs: TicketCreationDTO[] = []
		this._displayCategories.forEach(displayCategory => {
			let amountOfTickets = parseInt(displayCategory.standardPriceLevelControl.value, 10);
			if (amountOfTickets) {
				ticketCreationDTOs.push({
					priceLevelUUID: displayCategory.combinedPriceLevel.standard.uuid,
					ticketQuotaUUID: this._ticketQuota.uuid,
					numberOfTickets: amountOfTickets
				})
			}

			displayCategory.reducedPriceLevelsWithControl.forEach(reducedPriceLevelWithControl => {
				amountOfTickets =  parseInt(reducedPriceLevelWithControl.control.value, 10);
				if (amountOfTickets) {
					ticketCreationDTOs.push({
						priceLevelUUID: reducedPriceLevelWithControl.uuid,
						ticketQuotaUUID: this._ticketQuota.uuid,
						numberOfTickets: amountOfTickets
					})
				}
			})
		})

		this.ticketCreationDTOsCreated.emit(ticketCreationDTOs)
		this.resetForm()
	}

	private resetForm() {
		this._displayCategories = this._displayCategories.map(displayCategory =>
			Object.assign({}, displayCategory, { standardPriceLevelControl: new FormControl("") }))

		this._displayCategories.forEach(displayCategory => {
			displayCategory.reducedPriceLevelsWithControl = displayCategory.reducedPriceLevelsWithControl.map(priceLevelWithControl =>
				Object.assign({}, priceLevelWithControl, { control: new FormControl("") }))
		});
	}
}

interface DisplayCategoryWithControls extends ui.DisplayCategory {
	standardPriceLevelControl?: FormControl
	reducedPriceLevelsWithControl?: PriceLevelWithControl[]
}

interface PriceLevelWithControl extends model.PriceLevel {
	control?: FormControl
}



// WEBPACK FOOTER //
// ./src/app/components/event-tickets/ticket-category/ticket-categories.component.ts